import { Box, Paragraph } from '@deckee/deck-hand';
import React, { FC, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { captureEvent } from '../../../../services/event-capture';
import getBoundingAreasByLocation from '../../../../services/geofencing';
import { openWithInAppBrowser } from '../../../../services/in-app-browser';
import { selectCurrentLocation } from '../../../../services/store/modules/geo-service';
import BasicDrawerLayout from '../../../layouts/BasicDrawerLayout/BasicDrawerLayout';
import seaworthyInspectionsImage from '../assets/seaworthy-inspections-insurance-graphic.png';
import topsailInsuranceImage from '../assets/topsail-insurance-graphic.png';
import InsuranceCard, {
  InsuranceCardInterface,
} from '../components/InsuranceCard';

const INSURANCE_OFFERS = [
  {
    name: 'Get the best cover for your boat at the best price',
    description: (
      <>
        <Paragraph>
          Deckee has partnered with the boat insurance experts at Topsail to
          help you find the best policy for your needs. This is a free service
          for Deckee users.
        </Paragraph>
      </>
    ),
    imageUrl: topsailInsuranceImage,
    providerName: 'TopSail',
    url: `https://topsailinsuranceptyltd.cfsnetwork.co.uk/NewQuote/Boat/?lead=DECKEE`,
  },
  {
    name: 'Be prepared with an insurance condition report',
    description: (
      <>
        <Paragraph>
          Deckee has partnered with Seaworthy Inspections to help you ensure
          your boat is safe and compliant with regulations before hitting the
          water.
        </Paragraph>
      </>
    ),
    imageUrl: seaworthyInspectionsImage,
    providerName: 'Sea Worth',
    url: `https://seaworthyinspections.com.au/book-inspection/`,
    buttonText: 'Book now',
    geoFenceArea: 'AUSTRALIA',
  },
];

const handleSelectInsurance = async (insurance: InsuranceCardInterface) => {
  await captureEvent({
    type: 'insurance: offer redeemed',
    payload: {
      name: insurance.name,
      providerName: insurance.providerName,
    },
    sendToAmplitude: true,
  });
  const { url } = insurance;

  try {
    await openWithInAppBrowser({ url });
  } catch (err) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.location.href = url;
  }
};

const InsuranceListPage: FC = () => {
  const history = useHistory();

  const [boundingAreas, setBoundingAreas] = useState<string[] | null>(null);
  const { latitude, longitude } = useSelector(selectCurrentLocation);

  useEffect(() => {
    if (typeof latitude === 'number' && typeof longitude === 'number') {
      setBoundingAreas(
        getBoundingAreasByLocation({
          longitude,
          latitude,
        }),
      );
    }
  }, [latitude, longitude, setBoundingAreas]);

  return (
    <BasicDrawerLayout
      heading="Boat insurance"
      onBack={() => history.push('/maps/prepare')}
      loading={!boundingAreas}
    >
      <Box p="3">
        <div role="list" aria-label="insurance-list">
          {INSURANCE_OFFERS.filter(
            (insurance) =>
              !insurance.geoFenceArea ||
              boundingAreas?.includes(insurance.geoFenceArea),
          ).map((insurance) => (
            <InsuranceCard
              key={insurance.name}
              {...insurance}
              role="listitem"
              onSelectInsurance={handleSelectInsurance}
            />
          ))}
        </div>
      </Box>
    </BasicDrawerLayout>
  );
};

export default InsuranceListPage;
